import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ReactCountryFlag from 'react-country-flag'
import { Button } from '../../../features/section-components/Button'
import styles from '../MyAccount.module.scss'
import { getCountryCode } from '../../../features/language-selector/LanguageSelector'

function FlagAccountItemContainer({
  t, link, preferredLanguage, onClick, mobile, renderData, languageOptions
}) {
  if (mobile) {
    return (
      <div className={styles['mobile-account-item-container']} data-testid="renderData">
        {(preferredLanguage || !preferredLanguage)
          && renderData(
            t('label-pref-lang'),
            <>
              {preferredLanguage && (
                <ReactCountryFlag
                  countryCode={getCountryCode(preferredLanguage)}
                  svg
                  style={{ marginRight: 8, marginBottom: 3 }}
                />
              )}
              {languageOptions[preferredLanguage]
                || preferredLanguage}
            </>
          )}
        <Link
          to={link}
          style={{ display: 'inline-block', width: '100%' }}
          onClick={onClick}
        >
          <Button
            text={t('button-edit')}
            buttonStyle="cta-grey-oval-edit-profile-info-mobile"
            endIcon={<ArrowForwardIcon />}
            iconSize="small"
          />
        </Link>
      </div>
    )
  }
  return (
    <div className={styles['account-item-container']} data-testid="renderData">
      {(preferredLanguage || !preferredLanguage)
        && renderData(
          t('label-pref-lang'),
          <>
            {preferredLanguage && (
              <ReactCountryFlag
                countryCode={getCountryCode(preferredLanguage)}
                svg
                style={{ marginRight: 8, marginBottom: 3 }}
              />
            )}
            {languageOptions[preferredLanguage]
              || preferredLanguage}
          </>
        )}
      <Link
        to={link}
        style={{ display: 'inline-block' }}
        onClick={onClick}
      >
        <Button
          text={t('button-edit')}
          buttonStyle="cta-grey-oval-edit-profile-info"
          endIcon={<ArrowForwardIcon />}
          iconSize="small"
        />
      </Link>
    </div>
  )
}

FlagAccountItemContainer.propTypes = {
  t: PropTypes.func.isRequired,
  preferredLanguage: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  renderData: PropTypes.func.isRequired,
  languageOptions: PropTypes.objectOf(PropTypes.string),
  mobile: PropTypes.bool,
  link: PropTypes.string.isRequired
}

FlagAccountItemContainer.defaultProps = {
  mobile: false,
  languageOptions: {
    'en-US': 'English',
    'es-ES': 'Español',
    'ja-JP': '日本語',
    'ko-KR': '한국어',
    'nl-NL': 'Nederlands',
    'de-DE': 'Deutsch',
    'pt-PT': 'Português',
    'fr-FR': 'Français'
  }
}

export default FlagAccountItemContainer
